import {onCreateMessageByGroup, onUpdateMessageByGroup} from '@/store/subscriptions';
import store from '@/store'
import EventBus from '@/eventBus'
import { loadStaff,loadDevice, totalUnreadMessages, getMessengerAssociateDeviceList } from '@/views/Messenger/countUnreadMessages';
import { initializeSubscription, disconnectSubscription } from '../helper'
import { API } from 'aws-amplify'

"use strict";
let subscriptionMessage = null
let timeout = null

const subscription = {}

export const messengerLoadNotifications = function(forceReload){
    clearTimeout(timeout)
    timeout = setTimeout(async()=>{
        const { messengerList: {lastRenderKey} } = store.state.subscriptionStore
        if(forceReload){
            if(!lastRenderKey || (new Date) - lastRenderKey < 600000){
                return
            }
        }
        const listStaff = await loadStaff();
        const listDevice = await loadDevice();
        
        if(!listStaff && !listDevice) return
        
        // Load messenger list immediately with empty unread data to show threads
        const messengerList = getMessengerAssociateDeviceList( listStaff,listDevice, {} )
        store.dispatch("subscriptionStore/setMessengerList", messengerList)
        
        // Load unread messages asynchronously after threads are loaded
        API.get('messages', `/get-staffs-unread-messages/${store.state.userInfo.tenant.group}`)
            .then(resp => {
                const staffsUnreadMessages = resp.staffUnreadCounts || {}
                const apiTotalUnread = resp.totalUnreadMessages
                
                // Update messenger list with unread counts
                const updatedMessengerList = getMessengerAssociateDeviceList( listStaff,listDevice, staffsUnreadMessages )
                store.dispatch("subscriptionStore/setMessengerList", updatedMessengerList)
                
                // Update total notifications
                const notificationsUnreadMessages = apiTotalUnread !== undefined ? apiTotalUnread : totalUnreadMessages( updatedMessengerList );
                store.commit('setMessengerNotifications', notificationsUnreadMessages)
            })
            .catch(error => {
                console.error('Error loading staffs unread messages', error)
            })
    }, 1000)
}

export const messengerSubscribe = function(instance){
    const queries = {
        onCreateMessageByGroup,
        onUpdateMessageByGroup,
    }
    if(!store.state.userInfo?.tenant?.group) return
    const input = {
        group: store.state.userInfo.tenant.group
    }
    initializeSubscription(subscriptionMessage, queries, input, "subscriptionStore/handleMessenger", instance)
}

export const messengerUnsubscribe = function (instance) {
    disconnectSubscription(subscription, instance)
}

export const config = function(subscriptions){
    subscriptionMessage = subscriptions['messenger'] = {
        loadList: null,
        subscribe: messengerSubscribe,
        unsubscribe: messengerUnsubscribe,
        callback: messengerEventCallback,
        subscription
    }
}

export const messengerEventCallback = async function(subscriptionState, { eventName, data: message }) {
    if (!message) return;

    const associateLookupMap = store.getters["subscriptionStore/getAssociateLookupMap"];
    const deviceLookupMap = store.getters["subscriptionStore/getDeviceLookupMap"];
    const messengerLookupMap = store.getters["subscriptionStore/getMessengerLookupMap"];
    if (message.deviceId || message.device?.id) {
        const deviceId = message.deviceId || message.device?.id;
        const device = deviceLookupMap[deviceId];
        const chat = messengerLookupMap[deviceId];

        if (device && chat && (device.deviceLastMessageTimestamp !== message.createdAt || device.deviceLastMessage !== message.bodyText)) {
            chat.updateDeviceLastMessage(message);
            if (message.channelType === "RESPONSE" && message.senderName === null) {
                chat.messageUnread = (chat.messageUnread || 0) + 1;
                chat.readChat = false;
                store.dispatch("marNewkMessageRecieved");
            }
        }
    }
    if ((message.staffId || message.staff?.id) && message.channelType && ['SMS', 'EMAIL', 'RESPONSE'].includes(message.channelType)) {

        const staffId = message.staffId || message.staff?.id;
        const associate = associateLookupMap[staffId];
        const chat = messengerLookupMap[staffId];

        if (associate && chat && (associate.smsLastMessageTimestamp !== message.createdAt || associate.smsLastMessage !== message.bodyText)) {
            chat.updateSmsLastMessage(message);
            if (message.channelType === "RESPONSE" && message.senderName === null) {
                chat.messageUnread = (chat.messageUnread || 0) + 1;
                chat.readChat = false;
                store.dispatch("marNewkMessageRecieved");
            }
        }
    }

    switch (eventName) {
        case 'onCreate':
            EventBus.$emit('messenger-new-message-conversation', message);
            if(message.messageRouteId) EventBus.$emit('daily-roster-new-message', message);
            break;
        case 'onUpdate':
            EventBus.$emit('messenger-update-message-conversation', message);
            break;
    }
}
